import { Button, Heading, Text } from '@cue/atoms';
import { Modal, useModal } from '@cue/organisms';
import { ConsentTypes } from '@project/site/core/consent/consent';
import parse from 'html-react-parser';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

type CookieFallbackDialogProps = {
  open: boolean;
  onChoose: (type: ConsentTypes) => void;
};

/** Replacement for the Usercentrics dialog where its script cannot load (localhost). */
export const CookieFallbackDialog: React.FC<CookieFallbackDialogProps> = ({ open, onChoose }) => {
  const [modalRef] = useModal();
  const { t } = useTranslation();

  useEffect(() => {
    if (open) {
      modalRef.current?.open();
    } else {
      modalRef.current?.close();
    }
  }, [open, modalRef]);

  return (
    <Modal maxWidth={1000} ref={modalRef} hideCloseButton={true} id="cookie-consent">
      <div className="cue-project-cookie-consent">
        <div>
          <Heading type="h5">{t('cookies.headline')}</Heading>
          <Text>{t('cookies.copy')}</Text> <Text>{parse(t('cookies.copy-bottom'))}</Text>
        </div>
        <div className="cue-project-cookie-consent-buttons">
          <Button className="consent-required" onClick={() => onChoose(ConsentTypes.REQUIRED)}>
            {t('cookies.cta-required')}
          </Button>
          <Button className="consent-all" onClick={() => onChoose(ConsentTypes.ALL)}>
            {t('cookies.cta-full')}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
